module.exports = __webpack_public_path__ + "img/lock.15be9db8.svg";